import { ComponentGraphGroup } from '@ardoq/graph';
import {
  Constructor,
  type INode,
  INodeSizeConstraintProvider,
  type IRenderContext,
} from '@ardoq/yfiles';
import { GroupSizeConstraintProvider } from './GroupSizeConstraintProvider';
import { GroupVisual } from './GroupVisual';
import { ensureHeaderLayout } from './ensureHeaderLayout';
import { getGraphTag } from '../shared/layoutUtils';
import { ModernizedNodeStyleBase } from 'yfilesExtensions/styles/modernized/ModernizedNodeStyleBase';

class GroupStyle extends ModernizedNodeStyleBase {
  static Instance = new GroupStyle();
  private constructor() {
    super();
  }

  override createVisual(context: IRenderContext, node: INode) {
    const graphTag = getGraphTag(context);
    const groupHeaders = graphTag?.groupHeaders;
    if (!groupHeaders) return null;

    const { tag } = node;
    const graphNode = tag as ComponentGraphGroup;

    const layout = ensureHeaderLayout(node, groupHeaders);
    return new GroupVisual(
      node,
      graphNode,
      tag.getRepresentationData(),
      layout
    );
  }

  protected override lookup(node: INode, type: Constructor) {
    switch (type) {
      case INodeSizeConstraintProvider:
        return new GroupSizeConstraintProvider(node);
    }
    return super.lookup(node, type);
  }
}
export { GroupStyle };
